import { CoupomInterface,CoupomLotInterface } from "@/interfaces/Coupom.interface";
import api from "../config";

export class CoupomRest{
    getCoupons(params: any): Promise<any> {
        return api.get('/coupon', { params }).then((response) => response.data);
    }

    getCouponById(id: any): Promise<any> {
        return api.get(`/coupon/${id}`).then((response) => response.data);
    }

    getCheckCoupon(code: any): Promise<any> {
        return api.get(`/coupon/check/${code}`).then((response) => response.data);
    }

    deleteCoupon(id: any): Promise<any> {
        return api.delete(`/coupon/${id}`).then((response) => response.data);
    }

    createCoupon(data: any): Promise<any> {
        return api.post('/coupon', data).then((response) => response.data);
    }

    //Coupon Lot

    getCouponLots(params: any): Promise<any> {
        return api.get('/couponsLot', { params }).then((response) => response.data);
    }

    getCouponLotById(id: any): Promise<any> {
        return api.get(`/couponsLot/${id}`).then((response) => response.data);
    }

    deleteCouponLot(id: any): Promise<any> {
        return api.delete(`/couponsLot/${id}`).then((response) => response.data);
    }

    createCouponLot(data: any): Promise<any> {
        return api.post('/couponsLot', data).then((response) => response.data);
    }

    downloadCsvLot(id: any): Promise<any> {
        return api.post(`/couponsLot/${id}/`).then((response) => response.data);
    }

}